/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ReplyComment } from './ReplyComment';
import {
    ReplyCommentFromJSON,
    ReplyCommentFromJSONTyped,
    ReplyCommentToJSON,
} from './ReplyComment';

/**
 * 
 * @export
 * @interface CommentRepliesResponse
 */
export interface CommentRepliesResponse {
    /**
     * 
     * @type {Array<ReplyComment>}
     * @memberof CommentRepliesResponse
     */
    data?: Array<ReplyComment>;
}

/**
 * Check if a given object implements the CommentRepliesResponse interface.
 */
export function instanceOfCommentRepliesResponse(value: object): value is CommentRepliesResponse {
    let isInstance = true;

    return isInstance;
}

export function CommentRepliesResponseFromJSON(json: any): CommentRepliesResponse {
    return CommentRepliesResponseFromJSONTyped(json, false);
}

export function CommentRepliesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentRepliesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(ReplyCommentFromJSON)),
    };
}

export function CommentRepliesResponseToJSON(value?: CommentRepliesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ReplyCommentToJSON)),
    };
}

